module.exports = __webpack_public_path__ + "img/744.70ab60fd.jpg";